import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicTable, MASK_DECIMAL } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _CostingCenterHistory, _ProvisionCatalog } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountantYear } from "../ProductionPlan/AccountantYear";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { BasicButton } from "../../../../theme/Component/BasicButton";



interface Props {
    idAccount: number;
}

export const ProvisionCatalog = ({ idAccount }: Props) => {

    const vac = useDataBean(_ProvisionCatalog);

    const single = Singleton.getInstance();
    const [Year, setYear] = useState<any>(_single.getCurrenYear());
    const [lista, setLista] = useState<any>([]);
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });

    useEffect(() => {
        getLista();
    }, [Year, idAccount])

    const getLista = () => {

        vac.instance.getProvisionCatalog(Year, idAccount).then(
            (resp: any) => {
                if (resp) {
                    let x = resp;
                    x.forEach((user) => {
                        user.DataBeanProperties.Benefi = (user.DataBeanProperties.EmploymentBonusCode ?? "") + "-" + (user.DataBeanProperties.EmploymentBonusName ?? "");
                    });
                    setLista(x)
                }
            }
        )

    }

    const create = () => {
        vac.setBean({
            IDAccount: idAccount
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        vac.deleteItemVoid(vac.bean.IDProvision).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }
    const editaItem = () => {
        ////console.log(SubMacroProcess.bean);
        vac.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDProvision', visible: true },
        { title: 'Beneficio', property: 'Benefi', visible: true },
        { title: 'Cuenta Provisión', property: 'ProvAccountantIDStrName', visible: true },
        { title: 'Cuenta de Gasto', property: 'ExpAccountantIDStrName', visible: true },
        { title: 'Rubro Presupuestal', property: 'BudgetName', visible: true },
        { title: 'Valor Salario', property: 'SalaryValue', visible: true, mask: MASK_DECIMAL },
        { title: 'Beneficio Proyectado al 100%', property: 'ProjectedBenefit', visible: true, mask: MASK_DECIMAL },
        { title: 'Valor Beneficio a Pagar', property: 'TotalProvisionValue', visible: true, mask: MASK_DECIMAL },
        { title: 'Fecha Pago Beneficio', property: 'PaymentDate', visible: true },
        { title: 'Provisión Mensual', property: 'ProvisionAtMonth', visible: true, mask: MASK_DECIMAL },
        { title: 'Total Provisión Actual', property: 'ActualProvisionValue', visible: true, mask: MASK_DECIMAL },
        { title: '% Provisión Actual', property: 'TotalProvisionPercent', visible: true },
        { title: 'Meses Provisionados', property: 'ProvisionUnits', visible: true },
        { title: 'Meses a Provisionar', property: 'ProvisionCalculationMonths', visible: true },
        { title: 'Fecha Cálculo Actual', property: 'CalculationDate', visible: true },
        { title: 'Fecha Beneficio Desde', property: 'FromDate', visible: true },
        { title: 'Fecha Beneficio Hasta', property: 'UptoDate', visible: true },
        // { title: 'Fecha Actualización', property: 'LastUpdate', visible: true },
        { title: 'Perídos Pendientes de Vacaciones', property: 'VacPendingPeriods', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }



    return (
        <div className="row">
            <div className="col-md-6">
                <AccountantYear idSelector={Year} onChange={(e) => { setYear(e) }} />
            </div>
            <div className="col-md-2 mt-4 p-2">
                <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
            </div>
            <div className="col-md-12">
                <BasicTable body={lista} head={head} rowSet={vac.setBean} ></BasicTable>
                <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                    <div className="row">
                        <div className="col-md-12">
                            <label>Nombre</label>
                            <input type="text" name="Name" className="form-control" value={vac.bean.Name} onChange={vac.handleChange} />
                            {/* <SelectFunctionalID renderValue="" onChange={()=>{}}/> */}
                        </div>
                        <div className="col-md-12">
                            <label>Description</label>
                            <textarea name="Description" className="form-control" value={vac.bean.Description} onChange={vac.handleChange} />
                        </div>
                        {/* <PrintJson json={SubMacroProcess.bean} /> */}
                    </div>
                </Modal>

                <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                    <strong>Eliminar item</strong>
                </ModalConfirm>
            </div>

        </div>
    )
}